import { createFileRoute } from '@tanstack/react-router';
import { MeetingsTab } from '../components/features/project/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件詳細ページの「打ち合わせ」タブ。Meet作成ボタン・過去の打ち合わせ一覧・詳細（文字起こし・議事録）を表示する
 * @graph-connects MeetingsTab [calls] 打ち合わせタブ描画
 */
export const Route = createFileRoute('/projects/$pjKey/meetings')({
  component: ProjectMeetingsPage,
});

/** @graph-connects MeetingsTab [calls] 打ち合わせタブ描画 */
function ProjectMeetingsPage() {
  const { pjKey } = Route.useParams();
  return <MeetingsTab pjKey={pjKey} />;
}
